import { Pipe, PipeTransform } from '@angular/core';

import { FROM_ISO_TIME } from '@ppg/core/constants';

@Pipe({
  name: 'fromIso',
  standalone: true,
})
export class FromIsoPipe implements PipeTransform {
  transform(isoDuration: string | undefined): string {
    if (!isoDuration) {
      return '';
    }

    if (!isoDuration.startsWith('PT')) {
      return '';
    }

    const duration = FROM_ISO_TIME.exec(isoDuration);

    if (!duration) {
      return '';
    }

    const hours = parseInt(duration[1], 10) || 0;
    const minutes = parseInt(duration[2], 10) || 0;
    const seconds = parseInt(duration[3], 10) || 0;

    const totalMinutes = hours * 60 + minutes;
    const totalSeconds = seconds;

    const time = `${totalMinutes.toString().padStart(2, '0')}:${totalSeconds.toString().padStart(2, '0')}`;

    return time;
  }
}
